export default {
  find_products: 'Find products on Amazon',
  search_results: 'Search Results',
  product: 'Product',
  category: 'Category',
  sales_rank: 'Sales Rank (BSR)',
  listing_price: 'Listing Price',
  see_product_page: 'See Product Page',
  of_offers_count: '# Of Offers Count',
};
